function SectionHeading({ children, size, textAlignment = 'text-center' }) {
    return (
        <h3
            className={`font-bold ${
                size === 'xl' ? ' md:text-3xl' : ' md:text-5xl'
            } text-3xl xl:leading-tight ${textAlignment}`}>
            {children}
        </h3>
    )
}

export default SectionHeading
